import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Modal } from "@material-ui/core";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Form, Button, InputGroup } from "react-bootstrap";
import { useState } from "react";
import { checkEmailFormate, formatTime } from "../../utils/function";
import { toast } from "react-toastify";
import { forgotPassword } from "../../config/service";

const ForgetPassword = (props) => {
  const { t } = useTranslation();

  const [formValue, setformValue] = useState({
    email: "",
  });
  const [emailError, setEmailError] = useState(false);

  const handleClose = () => {
    props.handleBack("enter");
  };

  const validate = () => {
    let isValid = true;

    setEmailError("");

    if (!formValue.email) {
      isValid = false;
      setEmailError(t("Please enter email address"));
    } else if (!checkEmailFormate(formValue.email)) {
      isValid = false;
      setEmailError(t("Please enter valid email"));
    }

    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      handleForgotPassword();
    }
  };

  const handleForgotPassword = async () => {
    let data = {
      email: formValue.email,
      phone: props.formData.mobile,
      otp: props.otp,
      role: props.role,
      id: props.formData.id_number,
    };

    try {
      const response = await forgotPassword(data);
      const { status } = response;
      if (status === 201) {
        toast.success(t(response.data.message));
        if (response.data.message === "Expired OTP") {
          props.setPasswordMode("");
          return;
        }

        props.setPasswordMode("enter");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Modal
      open={props.passwordMode === "forgot"}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onClose={handleClose}
    >
      <div className="centered-modal">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Grid container direction="column" alignItems="center">
            <Grid item xs className="password-modal">
              <Paper className="paper password-body" square>
                <Grid container direction="column" alignItems="center">
                  <Grid item lg={12} className="back-btn">
                    <Button onClick={handleClose}>
                      {" "}
                      <ArrowBackIosNewIcon fontSize="small" />
                    </Button>
                  </Grid>
                  <Grid item lg>
                    <Typography variant="h4">{t("Forgot Password")}</Typography>
                  </Grid>
                  <Grid item sm xs={12} className="password-info">
                    <Typography variant="h6">
                      {t(
                        "Enter your email, we’ll send you a temporary password"
                      )}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} className="form-container">
                    <Form.Group>
                      <Form.Label>{t("Email")} *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="email"
                          type="email"
                          value={formValue.email || ""}
                          onChange={handleChange}
                          id="email"
                          className="text-center"
                          autoComplete="new-email"
                          autoFocus
                        />
                      </InputGroup>
                      {emailError && (
                        <span className="errorsmg">{t(`${emailError}`)}</span>
                      )}
                    </Form.Group>
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                    <Grid
                      item
                      xs
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "10px",
                      }}
                    >
                      <Button
                        type="submit"
                        className="submit"
                        style={{ maxWidth: "190px", margin: "0px auto" }}
                      >
                        {t("Submit")}
                      </Button>
                      <Typography variant="h6">
                        {props.passowrdTimer ? (
                          <span>{formatTime(props.passowrdTimer)}</span>
                        ) : (
                          t("")
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Form>
      </div>
    </Modal>
  );
};
export default ForgetPassword;
